module.exports = __webpack_public_path__ + "static/media/minions_banner_small.52a63c9e.png";